import type { ExecutionsHistoryErrorCode } from '@src/models/interfaces/executionsHistoryDashboard.interface';

export const HISTORY_SECTION_ERROR_MESSAGE_IDS: Record<ExecutionsHistoryErrorCode, string> = {
  TIMEOUT: 'dashboards.tasks.summary.section.timeout',
  NOT_IMPLEMENTED: 'dashboards.tasks.summary.section.notAvailable',
  IN_FLIGHT_LIMIT: 'dashboards.tasks.summary.section.inFlightLimit',
  UNKNOWN: 'dashboards.tasks.summary.section.error',
};

/** Returns a valid translation id even when a failed request has no error code. */
export const getHistorySectionErrorMessageId = (
  errorCode?: ExecutionsHistoryErrorCode,
): string => HISTORY_SECTION_ERROR_MESSAGE_IDS[errorCode ?? 'UNKNOWN'];
